import React, { useContext, useRef, useEffect, useState } from "react";
import { MdOutlineClose } from "react-icons/md";
import { IoPaperPlane } from "react-icons/io5";
import MessageVideo from "../OffCanvasComponents/MessageVideo";
import { AuthContext } from "../../contexts/AuthContext";
import "../../assets/css/component-meet-video-style.css";
import { sendMessageMeeting } from "../../services/sendMessageInbox";
import { socket } from "../../services/socket";

export default function OffcanvasMeeting({
  meetingId,
  messages,
  setMessages,
  accessCode,
  display,
  setDisplay,
  setNewMessage,
}) {
  const { user } = useContext(AuthContext);
  const formRef = useRef(null);
  const messageMeeting = useRef("messageMeeting");
  const boxOffcanvas = useRef(null);
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyAlert, setReplyAlert] = useState(null);

  // Fermer si clic a l'exterieur
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        boxOffcanvas.current &&
        !boxOffcanvas.current.contains(event.target) &&
        !event.target.closest(".offcanvas-toggle-button")
      ) {
        setNewMessage(false);
        setDisplay(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Listen for reply notifications
  useEffect(() => {
    const handleReplyNotif = (data) => {
      setReplyAlert(data);
    };
    socket.on("meeting_reply_notification", handleReplyNotif);
    return () => socket.off("meeting_reply_notification", handleReplyNotif);
  }, []);

  // Auto-dismiss reply alert after 1s
  useEffect(() => {
    if (!replyAlert) return;
    const timer = setTimeout(() => setReplyAlert(null), 1000);
    return () => clearTimeout(timer);
  }, [replyAlert]);

  const doSend = () => {
    if (
      messageMeeting.current.innerText.length > 0 &&
      messageMeeting.current.innerText.trim() !== ""
    ) {
      const payload = {
        userId: user.userId,
        userImage: user.userImage,
        displayName: `${user.prenom} ${user.nom}`,
        meetingId,
        accessCode,
        contenu: messageMeeting.current.innerText,
      };
      if (replyingTo) {
        payload.replyToId = replyingTo.id;
        payload.replyToContenu = replyingTo.contenu;
        payload.replyToSender = replyingTo.sender;
      }
      sendMessageMeeting(payload, setMessages);
      setReplyingTo(null);
    }
    messageMeeting.current.innerText = "";
  };

  const sendMessage = (evt) => {
    evt.preventDefault();
    doSend();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      doSend();
    }
  };

  const handleSwipeReply = (msg) => {
    setReplyingTo(msg);
    if (messageMeeting.current) messageMeeting.current.focus();
  };

  // Build a lookup for replyTo references
  const messagesById = {};
  messages.forEach((m) => {
    messagesById[m.id] = m;
  });

  return (
    <>
      {/* Reply alert notification */}
      {replyAlert && (
        <div className="meeting-reply-alert">
          <span className="meeting-reply-alert-text">
            {replyAlert.replierName} a repondu a votre message
          </span>
          <button
            className="meeting-reply-alert-close"
            onClick={() => setReplyAlert(null)}
          >
            <MdOutlineClose />
          </button>
        </div>
      )}

      {display ? (
        <div id="component-meet-video-style-chat-box" ref={boxOffcanvas}>
          <button
            className="chat-close-btn offcanvas-toggle-button"
            onClick={(evt) => {
              evt.stopPropagation();
              setNewMessage(false);
              setDisplay(false);
            }}
          >
            <MdOutlineClose style={{ fontSize: "18px" }} />
          </button>

          <div id="component-meet-video-style-chat-header">
            <div className="chat-title">Messages</div>
            <div id="component-meet-video-style-messages-info">
              Les messages ne peuvent être vus que par les personnes participant
              à la réunion et seront supprimés à la fin de celle-ci.
            </div>
          </div>

          <div
            id="component-meet-video-style-chats"
            style={{
              display: "flex",
              flexDirection: "column-reverse",
            }}
          >
            {messages.map((msg, idx) => (
              <MessageVideo
                key={idx + "__" + msg.id}
                keyId={idx + "__" + msg.id}
                position={user.userId === msg.sender.userId ? "right" : "left"}
                message={msg.contenu}
                peer={msg.sender}
                msgObject={msg}
                replyTo={
                  msg.replyToId
                    ? messagesById[msg.replyToId] || {
                        contenu: msg.replyToContenu,
                        sender: msg.replyToSender,
                      }
                    : null
                }
                onSwipeReply={handleSwipeReply}
              />
            ))}
          </div>

          <div id="component-meet-video-style-form">
            {/* Reply preview */}
            {replyingTo && (
              <div className="meeting-reply-preview">
                <div className="meeting-reply-preview-content">
                  <div className="meeting-reply-preview-author">
                    {replyingTo.sender?.displayName?.split(" ")[0]}
                  </div>
                  <div className="meeting-reply-preview-text">
                    {replyingTo.contenu?.length > 80
                      ? replyingTo.contenu.slice(0, 80) + "..."
                      : replyingTo.contenu}
                  </div>
                </div>
                <button
                  className="meeting-reply-preview-close"
                  onClick={() => setReplyingTo(null)}
                >
                  <MdOutlineClose />
                </button>
              </div>
            )}
            <div className="d-flex" ref={formRef}>
              <div
                ref={messageMeeting}
                contentEditable={true}
                onKeyDown={handleKeyDown}
                className="tyn-chat-form-input max-height-100px"
              ></div>
              <button onClick={sendMessage} className="chat-send-btn">
                <IoPaperPlane style={{ fontSize: "16px" }} />
              </button>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
